import React, { useEffect, useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
	Button,
	LinearProgressBar,
	LoadingComponent,
	Modal,
	Select,
	Table,
	Textfield,
} from "../../../components/core";
import { useDispatch, useSelector } from "react-redux";
import {
	addAddedData,
	clearData,
	getInitialData,
	getPartnerList,
	getPaymentModeList,
	handleOnEditAddedDataReducer,
	handleOnEditPaymentModeReducer,
} from "../../../features/payment-mode-and-fees/payment-mode-and-fees-slice";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
	ADD_PAYMENT_MODE,
	PARTNERS_FOR_PAYMENT_MODE_AND_FEES,
	PAYMENT_MODES,
	PAYMENT_MODE_AND_FEES_BY_PARTNER_ID,
	UPDATE_PAYMENT_MODE,
} from "../../../constants/graphql/payment-mode-and-fees-query";
import CellEditingTable from "./components/cell-editing-table";
import { Strings } from "../../../constants/strings";
import { Card } from "primereact/card";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";

export default function PaymentModeAndFees() {
	///For calling celleditcomplete
	const dummyInputRef = useRef(null);
	const [dummyInputValue, setDummyInputValue] = useState("");
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	// Utils
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// Redux States
	const initialData = useSelector(
		(state) => state.paymentModeAndFees.initialData
	);
	const addedData = useSelector((state) => state.paymentModeAndFees.addedData);
	const [editedData, setEditedData] = useState(initialData);
	const partnerList = useSelector(
		(state) => state.paymentModeAndFees.partnerList
	);
	const paymentModeList = useSelector(
		(state) => state.paymentModeAndFees.paymentModeList
	);
	// Local Statesf
	const [partnerId, setPartnerId] = React.useState("-1");
	const [isClicked, setIsClicked] = React.useState(false);

	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [initialPaymentModeAndFees, setInitialPaymentModeAndFees] =
		React.useState([]);
	const [remainingPaymentMode, setCurrentRemainingPaymentMode] = React.useState(
		[]
	);
	const [changesMade, setChangesMade] = useState(false);
	const [tableUpdating, setTableUpdating] = React.useState(false);
	// Graphql
	const paymentModes = useQuery(PAYMENT_MODES);
	const partners = useQuery(PARTNERS_FOR_PAYMENT_MODE_AND_FEES, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
	});
	const [paymentModeAndFeesByPartnerId, { refetch, loading }] = useLazyQuery(
		PAYMENT_MODE_AND_FEES_BY_PARTNER_ID,
		{ fetchPolicy: "no-cache" }
	);
	console.log({ loading });
	const [addPaymentMode] = useMutation(ADD_PAYMENT_MODE);
	const [updatePaymentMode] = useMutation(UPDATE_PAYMENT_MODE);

	// zustand
	const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

	const handleSaveChanges = async () => {
		dummyInputRef.current.focus();
		setDummyInputValue("Asdasdasd");
		document.getElementById("dummyInputRef").click();

		let combinedAddandInitialData = initialData.concat(addedData);

		let filteredEmptyData = combinedAddandInitialData.filter(
			(x) => x.codRate === "" || x.codRate === null
		);
		let filteredMaxCodRateReached = combinedAddandInitialData.filter(
			(x) => x.codRate > 99 || x.codRate < 1
		);
		let filteredDuplicatePaymentMode = combinedAddandInitialData.filter(
			(obj, index, self) =>
				self.findIndex((o) => o.paymentModeId === obj.paymentModeId) !== index
		);

		if (partnerId === "-1") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete criteria",
				message: "Please select a partner first.",
				open: true,
				actions: (
					<div className="gap-2 text-center">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 mx-auto w-full"}
						/>
					</div>
				),
			});
		} else if (filteredEmptyData.length > 0) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: Strings.popup_error_title_empty_field,
				message: Strings.popup_error_message_empty_field,
				open: true,
				actions: (
					<div className="gap-2 text-center">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 mx-auto w-full"}
						/>
					</div>
				),
			});
		} else if (filteredDuplicatePaymentMode.length > 0) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: Strings.popup_error_title_duplicate,
				message: Strings.popup_error_message_duplicate,
				open: true,
				actions: (
					<div className="gap-2 text-center">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 mx-auto w-full"}
						/>
					</div>
				),
			});
		} else if (filteredMaxCodRateReached.length > 0) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Max/Min Limit Reached",
				message: "Payment mode rate must be 1 - 100 percent only.",
				open: true,
				actions: (
					<div className="gap-2 text-center">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 mx-auto w-full"}
						/>
					</div>
				),
			});
		} else {
			setTableUpdating(true);

			// let paymentModeListSoft = [...paymentModeList];
			// let initialDataSoft = [...initialData];
			let newPaymentModeList = paymentModeList.filter(
				(item1) =>
					!initialData.some((item2) => item2.paymentModeId === item1.value)
			);

			await updatePaymentModes(initialData);

			// updatePaymentMode({ variables: { payments: editedData } }).then(() => {
			// 	setValidation({
			// 		icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
			// 		title: Strings.popup_success_title_default,
			// 		message: Strings.popup_success_message_edit,
			// 		open: true,
			// 		actions: (
			// 			<div className="gap-2 text-center">
			// 				<Button
			// 					onClick={() => {
			// 						setValidation({ open: false });
			// 						setChangesMade(false);
			// 						window.location.reload();
			// 					}}
			// 					value={"OK"}
			// 					className={"p-2 mx-auto w-full"}
			// 				/>
			// 			</div>
			// 		),
			// 	});
			// });
			addPaymentMode({
				variables: {
					payments: addedData,
				},
			}).catch((e) => {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: Strings.popup_error_title,
					message: Strings.popup_error_message_add,
					open: true,
					actions: (
						<div className="gap-2 text-center">
							<Button
								onClick={() => {
									setValidation({ open: false });
									setChangesMade(false);
									window.location.reload();
									// refetch();
								}}
								value={"OK"}
								className={"p-2 mx-auto w-full"}
							/>
						</div>
					),
				});
			});

			// paymentModeAndFeesByPartnerId({
			// 	variables: {
			// 		operatorId: localStorage.getItem("user")
			// 			? JSON.parse(localStorage.getItem("user")).operator_id
			// 			: "",
			// 		partnerId: partnerId,
			// 	},
			// }).then((data) => {
			// 	setTableUpdating(false);
			// 	const partnerCodPaymentFeesArr =
			// 		data.data.partners[0].partnerCodPaymentFees;
			// 	let tempArr = [];
			// 	partnerCodPaymentFeesArr.forEach((element) => {
			// 		tempArr.push({
			// 			partnerCodPaymentFeeId: element.partnerCodPaymentFeeId,
			// 			paymentModeId: element.paymentMode.paymentModeId,
			// 			partnerId: partnerId,
			// 			codRate: element.codRate * 100,
			// 		});
			// 	});
			// 	dispatch(getInitialData(tempArr));
			// 	setInitialPaymentModeAndFees(tempArr);
			// });
			// dispatch(getInitialData([...initialData, ...addedData]));
			// setInitialPaymentModeAndFees([...initialData, ...addedData]);
			// dispatch(clearData());
		}
	};

	// Update payment modes
	const updatePaymentModes = async (editedData) => {
		await updatePaymentMode({ variables: { payments: editedData } });
		setValidation({
			icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
			title: Strings.popup_success_title_default,
			message: Strings.popup_success_message_edit,
			open: true,
			actions: (
				<div className="gap-2 text-center">
					<Button
						onClick={() => {
							setValidation({ open: false });
							setChangesMade(false);
							window.location.reload();
							// refetch();
						}}
						value={"OK"}
						className={"p-2 mx-auto w-full"}
					/>
				</div>
			),
		});
	};
	const handleCancelChanges = () => {
		window.location.reload();
		dispatch(clearData());
		dispatch(getInitialData(initialPaymentModeAndFees));
		// setChangesMade(false);
		setValidation({ open: false });
	};

	// console.log({ editedData });
	const handleOnEditPaymentMode = (rowId, newValue, field) => {
		dispatch(
			handleOnEditPaymentModeReducer({
				rowId: rowId,
				newValue: newValue,
				field: field,
			})
		);
		setChangesMade(true);

		// let updatedData = initialData.map((item) => {
		// 	// If the row has been edited, replace the old value with the new value
		// 	if (item[rowId] === initialData[rowId]) {
		// 		return { ...item, [field]: newValue };
		// 	}
		// 	return item; // Otherwise, leave the row unchanged
		// });
	};

	useEffect(() => {
		if (initialData) {
			setEditedData(initialData);
		}
	}, [initialData]);
	useEffect(() => {
		if (pendingNavigation !== null) {
			if (changesMade) {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: `${Strings.popup_confirm_cancel_title}?`,
					message: Strings.popup_confirm_cancel_massage,
					open: true,
					actions: (
						<div className="flex justify-between gap-3">
							<Button
								onClick={() => {
									setValidation({ open: false });
									// window.location.reload();
									setPendingNavigation(null);
									setActiveSubItem(activeSubItem);
								}}
								value={"No"}
								className={"p-2 w-full"}
							/>
							<Button
								onClick={() => {
									navigate(pendingNavigation);
									setPendingNavigation(null);
								}}
								value={"Yes"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			} else {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}
	}, [pendingNavigation, changesMade]);

	console.log({ initialData, editedData });
	const handleOnEditAddedData = (event, id) => {
		const { name, value } = event.target;
		dispatch(
			handleOnEditAddedDataReducer({ name: name, id: id, value: value })
		);

		// let updatedData = initialData.map((item) => {
		// 	// If the row has been edited, replace the old value with the new value
		// 	if (item[rowId] === initialData[rowId]) {
		// 		return { ...item, [field]: newValue };
		// 	}
		// 	return item; // Otherwise, leave the row unchanged
		// });
		// setEditedData(updatedData);
	};
	const handleSelectPartner = (event) => {
		const { value } = event.target;
		setChangesMade(false);
		setIsClicked(false);
		setPartnerId(value);
		dispatch(clearData());
		// setTableUpdating(true);

		// let tempEditedData = [...editedData];
		// editedData.forEach((element, key) => {
		//   let obj = { ...tempEditedData[key] };
		//   obj.partnerId = value;
		//   tempEditedData[key] = obj;
		// });
	};
	console.log({ partnerId });

	const handleSearch = () => {
		if (partnerId === "-1") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: Strings.popup_error_title,
				message: "Required Field Missing",
				open: true,
				actions: (
					<div className="gap-2 text-center">
						<Button
							onClick={() => {
								setValidation({ open: false });
								// setChangesMade(false);
								// window.location.reload();
								// refetch();
							}}
							value={"OK"}
							className={"p-2 mx-auto w-full"}
						/>
					</div>
				),
			});
		} else {
			setIsClicked(true);
			paymentModeAndFeesByPartnerId({
				variables: {
					operatorId: localStorage.getItem("user")
						? JSON.parse(localStorage.getItem("user")).operator_id
						: "",
					partnerId: partnerId,
				},
			}).then((data) => {
				const partnerCodPaymentFeesArr =
					data.data.partners[0].partnerCodPaymentFees;
				let tempArr = [];
				let initialArr = [];
				partnerCodPaymentFeesArr.forEach((element) => {
					tempArr.push({
						partnerCodPaymentFeeId: element.partnerCodPaymentFeeId,
						paymentModeId: element.paymentMode.paymentModeId,
						partnerId: partnerId,
						codRate: (element.codRate * 100).toFixed(2),
					});
					initialArr.push({
						...element,
						paymentMode: element.paymentMode.paymentMode,
						partnerCodPaymentFeeId: element.partnerCodPaymentFeeId,
						paymentModeId: element.paymentMode.paymentModeId,
						partnerId: partnerId,
						codRate: (element.codRate * 100).toFixed(2),
					});
				});
				dispatch(getInitialData(tempArr));
				setInitialPaymentModeAndFees(initialArr);
			});
			console.log({ initialPaymentModeAndFees, initialData });
		}
	};
	const handleAddPaymentMode = () => {
		setChangesMade(false);

		dispatch(
			addAddedData({
				paymentModeId: "1",
				partnerId: partnerId,
				codRate: "",
			})
		);
	};

	// Use Effects
	React.useEffect(() => {
		if (paymentModes.data) {
			let tempVar = [];
			paymentModes.data.paymentModes.forEach((element) => {
				tempVar.push({
					value: element.paymentModeId,
					name: element.paymentMode,
				});
			});
			dispatch(getPaymentModeList(tempVar));
		}
	}, [paymentModes.data]);

	React.useEffect(() => {
		if (partners.data) {
			let tempVar = [];
			partners.data.partners.forEach((element) => {
				tempVar.push({
					value: element.partnerId,
					name: element.companyNickname,
				});
			});
			dispatch(getPartnerList(tempVar));
		}
	}, [partners.data]);

	React.useEffect(() => {
		let paymentModeListSoft = [...paymentModeList];
		let initialDataSoft = [...initialData];
		let newPaymentModeList = paymentModeListSoft.filter(
			(item1) =>
				!initialDataSoft.some((item2) => item2.paymentModeId === item1.value)
		);
		setCurrentRemainingPaymentMode(newPaymentModeList);
	}, [initialData]);

	return (
		<ContentContainer containerTitle={"Payment Mode and Fees"}>
			<div className="w-2/3 pb-5">
				<div className="grid grid-cols-8 items-center gap-2 w-full">
					<p className="col-span-1">Partner:</p>
					<Select
						items={partnerList}
						onChange={handleSelectPartner}
						defaultOption={{ value: "-1", name: "-- Select Partner --" }}
						className={"col-span-3"}
						id="forClickOutisde"
					/>
					<Button
						value={"Search"}
						className={"col-span-1"}
						onClick={handleSearch}
					/>
				</div>
				<LinearProgressBar open={tableUpdating} label="Table is updating..." />
			</div>
			{/* <Card className="w-full"> */}
			{/*  */}
			{isClicked &&
			(accessPermission.paymentModeAndFees === 1 ||
				accessPermission.paymentModeAndFees === "1") ? (
				<>
					<Card className="w-full">
						<div className="bg-primary-primaryYellow w-full mt-4 p-4 text-center border-secondary-buttonHeaderGray border-2">
							<p className="font-bold text-xl">
								{partnerId !== "-1" &&
									partnerList.find((x) => x.value === partnerId).name}{" "}
								Payment Modes
							</p>
						</div>
						<Table
							headers={[
								{
									header_key: "paymentMode",
									header_name: "Payment Mode",
									type: "select",
								},
								{
									header_key: "codRate",
									header_name: "Rate",
									type: "numberfield",
								},
							]}
							items={initialPaymentModeAndFees}
						/>
					</Card>
				</>
			) : (
				<>
					{/* partnerId !== "-1" */}
					{!loading ? (
						isClicked && (
							<>
								<Card className="w-full">
									<div className="bg-primary-primaryYellow w-full mt-4 p-4 text-center border-secondary-buttonHeaderGray border-2">
										<p className="font-bold text-xl">
											{partnerId !== "-1" &&
												partnerList.find((x) => x.value === partnerId)
													.name}{" "}
											Payment Modes
										</p>
									</div>
									<CellEditingTable
										paymentModeList={paymentModeList}
										data={initialData}
										editedData={editedData}
										setEditedData={setEditedData}
										setInitialData={setInitialPaymentModeAndFees}
										headers={[
											{
												field: "paymentModeId",
												header: "Payment Mode",
												type: "select",
											},
											{ field: "codRate", header: "Rate", type: "numberfield" },
										]}
										primaryKey={"partnerCodPaymentFeeId"}
										handleOnCellEditComplete={handleOnEditPaymentMode}
										currentPaymentMode={remainingPaymentMode}
									/>
									{initialData.length < 3 && (
										<Button
											disabled={
												initialData.concat(addedData).length === 3 ||
												accessPermission.paymentModeAndFees === 1 ||
												accessPermission.paymentModeAndFees === "1"
													? true
													: false
											}
											value={"Add form"}
											className={`p-2 mx-auto my-4 ${
												changesMade ? "hidden" : ""
											}`}
											onClick={handleAddPaymentMode}
										/>
									)}
									{/* for adding */}
									{addedData.map((data, key) => {
										return (
											<div className="flex gap-2" key={key}>
												<div className="grid grid-cols-2 gap-2 my-4 w-full shadow-lg p-2">
													<Select
														items={paymentModeList}
														onChange={(event) =>
															handleOnEditAddedData(event, key)
														}
														name="paymentModeId"
														id={key}
														value={addedData[key].paymentModeId}
													/>
													<div className="flex flex-row items-center">
														<Textfield
															className="border-2 focus:outline-yellow-400 rounded-md p-1 w-max"
															value={addedData[key].codRate}
															name="codRate"
															onChange={(e) => {
																setChangesMade(true);
																var numberPattern = /^\d+(\.\d{0,2})?$/;
																if (
																	numberPattern.test(e.target.value) ||
																	e.target.value === ""
																) {
																	if (
																		parseFloat(e.target.value) <= 100 ||
																		e.target.value === ""
																	)
																		handleOnEditAddedData(e, key);
																}
															}}
														/>
														<p className="ml-[-22px]" style={{ zIndex: "3" }}>
															%
														</p>
													</div>
												</div>
											</div>
										);
									})}
									{changesMade && (
										<div className="w-full grid grid-cols-2 gap-4 my-4">
											<Button
												className={"p-2"}
												value="Cancel"
												disabled={
													accessPermission.paymentModeAndFees === 1 ||
													accessPermission.paymentModeAndFees === "1"
												}
												onClick={() => {
													setValidation({
														icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
														title: "Cancel changes",
														message: "Are you sure you want to cancel changes?",
														open: true,
														actions: (
															<div className="grid grid-cols-2 gap-2">
																<Button
																	onClick={() => setValidation({ open: false })}
																	value={"No"}
																	className={"p-2"}
																/>
																<Button
																	onClick={handleCancelChanges}
																	value={"Yes"}
																	className={"p-2"}
																/>
															</div>
														),
													});
												}}
											/>
											<Button
												className={"p-2"}
												id="forClickingTwice"
												value="Save Changes"
												disabled={
													accessPermission.paymentModeAndFees === 1 ||
													accessPermission.paymentModeAndFees === "1"
												}
												onClick={() => {
													///TODO: Close cursor so field will call oneditingdone
													dummyInputRef.current.focus();
													setValidation({
														icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
														title: "Save changes",
														message: "Are you sure you want to save changes?",
														open: true,
														actions: (
															<div className="grid grid-cols-2 gap-2">
																<Button
																	onClick={() => setValidation({ open: false })}
																	id="forClickingTwice1"
																	value={"No"}
																	className={"p-2"}
																/>
																<Button
																	onClick={handleSaveChanges}
																	value={"Yes"}
																	className={"p-2"}
																/>
															</div>
														),
													});
												}}
											/>
										</div>
									)}
								</Card>
							</>
						)
					) : (
						<LoadingComponent />
					)}
				</>
			)}
			{/* </Card> */}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
			<input
				type="text"
				ref={dummyInputRef}
				style={{ display: "hidden", width: "0px", height: "0px" }}
				value={dummyInputValue}
				id="dummyInputRef"
			/>{" "}
			{/* Hidden dummy input */}
		</ContentContainer>
	);
}
